import React from 'react';
import { Checkbox } from 'baseui/checkbox';
import { Select } from 'baseui/select';
import { validationTypes, ALLOWED_FILE_TYPES_DEFAULT_OPTIONS, type QuestionType, type Validation } from '../../../../reducers';
import { isEmpty } from '../../../../utils/answer';
import { ValidationRow } from '../styled-components';
import { getValidationByType } from '../utils';
import { type ValidationReducerActionTypeT } from '../reducers';
type PropsT = {
  question: QuestionType;
  validationState: Array<Validation | undefined | null>;
  dispatch: (a: {
    kind?: string;
    type: ValidationReducerActionTypeT;
    value?: string;
  }) => void;
};
export default function AcceptedFileTypesValidation({
  question,
  validationState,
  dispatch
}: PropsT) {
  const acceptedFileTypesValidation = getValidationByType(validationState, validationTypes.ACCEPTED_FILE_TYPES);
  return <ValidationRow>
      <Checkbox checked={validationState.some(validation => validation?.type === validationTypes.ACCEPTED_FILE_TYPES)} onChange={e => {
      if (e.target.checked) {
        dispatch({
          type: 'ADD_VALIDATION',
          value: validationTypes.ACCEPTED_FILE_TYPES
        });
      } else {
        dispatch({
          type: 'REMOVE_VALIDATION',
          value: validationTypes.ACCEPTED_FILE_TYPES
        });
      }
    }}>
        Allowed File Types
      </Checkbox>{' '}
      {!!acceptedFileTypesValidation && <Select placeholder="Choose allowed file types from list or input a file extension" required creatable multi options={ALLOWED_FILE_TYPES_DEFAULT_OPTIONS} value={!isEmpty(acceptedFileTypesValidation?.value) ? acceptedFileTypesValidation.value.split(',').map(val => ({
      id: val,
      label: val
    })) : []} onChange={({
      value
    }) => {
      dispatch({
        type: 'ADD_VALUE',
        kind: validationTypes.ACCEPTED_FILE_TYPES,
        value: value.map(val => val.id).join(',')
      });
    }} noResultsMsg="Input a file extension that should be allowed e.g. jpeg, pdf, csv, etc." getOptionLabel={({
      option
    }) => option.isCreatable ? `Allow "${option.id || ''}" files` : option.label || ''} />}
    </ValidationRow>;
}